import { useEffect, useMemo } from "react";
import { useApplicationId } from "../hooks/useApplicationId";
import { ACTIONS, useSelfEvaluationInfoContext } from "../Form/SelfEvaluationInfoContext";
import { useLazyGetCriteriaRatingTickBySGBPProductInformationIdQuery } from "../../../../../../app/services/SelfEvaluationForm/selfEvalutionServiceApi";
import { RATING_LEVELS } from "./Constants";
import { calcSectionCRating } from "./Sectioncrating";

const SectionCRatingBox = ({ requirements }) => {
    const applicationId = useApplicationId();
    const { state, dispatch } = useSelfEvaluationInfoContext();
    // const { data: tickRating } = useLazyGetCriteriaRatingTickBySGBPProductInformationIdQuery(applicationId, {
    //     skip: !(applicationId > 0),
    // });

    const [getData, { data: tickRating }] = useLazyGetCriteriaRatingTickBySGBPProductInformationIdQuery();


    const submittedCount = useMemo(
        () => requirements.filter((item) => state.requirements[item.sgbpRequirementId]?.files?.length > 0).length,
        [requirements, state.requirements]
    );

    const rating = useMemo(() => calcSectionCRating(tickRating, submittedCount), [tickRating, submittedCount]);

    useEffect(() => {
        if (applicationId > 0) getData(applicationId);
    }, [applicationId]);
    useEffect(() => {
        dispatch({ type: ACTIONS.SET_SECTION_C_COUNT, value: rating });
    }, [dispatch, rating]);

    return (
        <div className="rating-box">
            <h4>Section C Additional Information</h4>
            <table className="rating-table">
                <tbody>
                    {RATING_LEVELS.map((tick) => (
                        <tr key={tick}>
                            <td>{tick} Tick</td>
                            <td>
                                <span>
                                    <input
                                        disabled
                                        readOnly
                                        className="change-value"
                                        value={tickRating?.[`rating${tick}Tick`] || 0}
                                    />
                                    / {requirements.length}
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default SectionCRatingBox;